import { ogImage, OG_SIZE } from "@/lib/og";

export const alt = "Contact Quto AI — Get in touch";
export const size = OG_SIZE;
export const contentType = "image/png";

export default function Image() {
  return ogImage({ title: "Contact Quto AI", eyebrow: "Get in touch" });
}
